import React, { useMemo } from 'react';
import proptypes from 'prop-types';
import classnames from 'classnames';
import { HomepageContext } from './HomepageContext';
import { useWindowWidth } from '../../hooks';

const { element, shape } = proptypes;

export function HomepageProvider({ value = {}, children }) {
  const windowWidth = useWindowWidth();
  const { isB2C } = value || {};
  // eslint-disable-next-line tailwindcss/no-arbitrary-value
  const defaultCardClass = classnames(
    'sui-h-full',
    { '!sui-rounded-[12px]': isB2C }
  );

  const contextValue = useMemo(
    () => ({ ...value, windowWidth, defaultCardClass }),
    [value, windowWidth, defaultCardClass]
  );

  return (
    <HomepageContext.Provider value={contextValue}>
      {children}
    </HomepageContext.Provider>
  );
}

HomepageProvider.propTypes = {
  value: shape({}),
  children: element,
};

HomepageProvider.defaultProps = {
  value: {},
  children: undefined,
};
